import { PaginationResultDTO } from './PaginationResultDTO';

interface LoadProps<T> {
  fetchFn: (props: { page: number }) => Promise<PaginationResultDTO<T[]>>;
  maxParallellRequestsCount?: number;
}

export const fetchPaginatedDataInParallel = async <T>({
  fetchFn,
  maxParallellRequestsCount = 3,
}: LoadProps<T>): Promise<T[]> => {
  const allItems: T[] = [];

  // Fetch first page to get total pages
  const firstPageData = await fetchFn({ page: 0 });

  const totalPages = firstPageData.totalPages;

  allItems.push(...firstPageData.result);

  if (totalPages > 1) {
    const remainingPages = Array.from({ length: totalPages - 1 }, (_, i) => i + 1);

    for (let i = 0; i < remainingPages.length; i += maxParallellRequestsCount) {
      const pageChunk = remainingPages.slice(i, i + maxParallellRequestsCount);

      // Fetch pages in parallel
      const pagesData = await Promise.all(pageChunk.map((page) => fetchFn({ page })));

      pagesData.forEach((data) => {
        allItems.push(...data.result);
      });
    }
  }

  return allItems;
};
